import { STATUS_STRINGS } from '@master/constants';

export default (value, uppercase = true) => {
  let output = STATUS_STRINGS[value] ?? 'Unknown';
  if (uppercase) {
    output = output.toUpperCase();
  }
  return output;
};
